<template>
  <div class="premium-indicator">
    <img src="../assets/images/exclusive.svg" >
  </div>
</template>

<script>
import thumbnailIndicator from '../assets/images/exclusive.svg';
import wideIndicator from '../assets/images/exclusive tag rounded.svg';

export default {
  data() {
    return {
      thumbnailIndicator,
      wideIndicator,
    };
  },
  computed: {
    imgSrc() {
      if (this.mediaSize === 'wide' || this.mediaSize === 'featured') {
        return wideIndicator;
      }

      return thumbnailIndicator;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

  .premium-indicator {
    position: absolute;
    top: 5px;
    left: 5px;
    background-color: $brand;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 14px;
      height: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// app/src/components/PremiumIndicator.vue